<template>
 
       <fragment>             
                               
                                <th>Dsttest</th>
                                <th>Dstdate</th>
                                <th>Dstres</th>
                            
                              
        </fragment>                     
                    
                  
</template>

<script>



export default {
  name: 'Header',
  data () {
    return {
    }
  },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    
     
</style>
